import { render, staticRenderFns } from "./DiagnosticReportTemplate.vue?vue&type=template&id=c29590aa&"
import script from "./DiagnosticReportTemplate.vue?vue&type=script&lang=js&"
export * from "./DiagnosticReportTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports